import {
  ZOHOINTEGRATION_HTTP_SUCCESS,
  EDITZOHOINTEGRATION_HTTP_SUCCESS,
  ZOHOINTEGRATION_HTTP_FAILURE,
  EDITZOHOINTEGRATION_HTTP_FAILURE,
  RESET_FLAG,
  ZOHOINTEGRATIONAUTH_HTTP_SUCCESS,
  ZOHOINTEGRATIONAUTH_HTTP_FAILURE,
} from '../actions/typeConstants';

import { parseError } from 'utils/misc';

const initialState = {
  zohoIntegrationData: null,
  successMsg: null,
  errorMsg: null,
  errorCode: null,
  zohoIntegrationAuth: null,
}

export default function(state = initialState, action) {
  switch(action.type) {
    case ZOHOINTEGRATION_HTTP_SUCCESS:
      return { ...state, zohoIntegrationData: action.data, errorMsg: null, errorCode: null }
    case ZOHOINTEGRATIONAUTH_HTTP_SUCCESS:
      return { ...state, zohoIntegrationAuth: action.data, errorMsg: null, errorCode: null }
    case ZOHOINTEGRATION_HTTP_FAILURE:
      return { ...state, errorMsg: parseError(action.error.response.text), successMsg: null, errorCode: action.error.response.status }
    case ZOHOINTEGRATIONAUTH_HTTP_FAILURE:
      return { ...state, errorMsg: parseError(action.error.response.text), successMsg: null, errorCode: action.error.response.status }
    case EDITZOHOINTEGRATION_HTTP_SUCCESS:
      return { ...state, zohoIntegrationData: action.data, successMsg: 'Saved!', errorMsg: null}
    case EDITZOHOINTEGRATION_HTTP_FAILURE:
      return { ...state, errorMsg: parseError(action.error.response.text), successMsg: null, errorCode: action.error.response.status }
    case RESET_FLAG:
      return {...state, successMsg: null, errorMsg: null, errorCode: null, zohoIntegrationAuth: null,}
    default:
      return { ...state }
  }
}
